<template>
  <div>
    <ScreenViewHeader :title="categoryName" />
    <v-container>
      <div>
        <ApolloQuery
          :query="(gql) => getLocalBooksBySubject"
          :variables="{
            subjectCode: subjectCode,
            page: 1,
          }"
          :update="(data) => data?.localBooks?.collection || []"
        >
          <template #default="{ result: { error, data }, isLoading, query }">
            <book-display
              :data="data"
              :is-loading="!!isLoading"
              :error="error"
              :query="query"
              :loading-items="loadingItemsCount"
            />
            <v-container v-if="(!data || data.length === 0) && !isLoading">
              <v-row justify="center">
                <v-col
                  class="col-12 col-sm-8 pa-16"
                >
                  <book-list-icon :size="72" />
                  <h1>{{ $t('shop.noBooksFound') }}</h1>
                  <v-btn
                    tile
                    block
                    color="primary"
                    class="mt-4"
                    :to="{ name: 'home' }"
                  >
                    {{ $t('common.returnToShop') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </template>
        </ApolloQuery>
      </div>
    </v-container>
  </div>
</template>

<script>
import BookListIcon from "@/components/icons/BookListIcon";
import LocalBookFragments from "@/graphql/LocalBookFragments";
import BookDisplay from "@/components/BookDisplay";
import gql from "graphql-tag";
import ScreenViewHeader from "@/components/ScreenViewHeader.vue";

const LOADING_ITEM_COUNT = 12;

export default {
  name: "FilteredBookList",
  metaInfo() {
    return {
      title: this.$route.params.name || this.$t('routes.browseBySubject'),
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.$t('seo.browseDescription', { name: this.$route.params.name || '' }),
        },
      ],
    }
  },
  components: {
    BookListIcon,
    BookDisplay,
    ScreenViewHeader,
  },
  data() {
    return {
      loadingItemsCount: LOADING_ITEM_COUNT,
    };
  },
  computed: {
    subjectCode() {
      return this.$route.params.code;
    },
    categoryName() {
      return this.$route.params.name;
    },
    getLocalBooksBySubject() {
      return gql`query localBooksBySubject($subjectCode: String, $page: Int) {
          localBooks(subjects_code: $subjectCode, page: $page) {
            __typename
            collection {
              ...LocalBookCore
            }
          }
        }
        ${LocalBookFragments.localBookCoreFragment}
      `
    },
  },
};
</script>
